class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._openTimer = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // Our header wraps onto multiple rows, so reaching an open panel below
    // a row-1 item usually means the cursor briefly crosses a row-2/3 item
    // on the way down. Closing on a per-item mouseleave (the old approach)
    // let that sibling hijack the hover and slam the open panel shut before
    // the click landed. Instead, treat the *whole* inline menu — every tab
    // plus every open panel, since panels are DOM descendants of their tab
    // — as one hover zone: nothing closes while the cursor is still
    // somewhere inside it, no matter which item it's currently over.
    HeaderMenu.initSharedZone();
  }

  static initSharedZone() {
    if (HeaderMenu._zoneInit) return;
    HeaderMenu._zoneInit = true;
    HeaderMenu._closeTimer = null;
    const zone = document.querySelector('.header__inline-menu') || document.querySelector('.header-wrapper');
    if (!zone) return;
    zone.addEventListener('mouseenter', () => clearTimeout(HeaderMenu._closeTimer));
    zone.addEventListener('mouseleave', () => {
      if (window.innerWidth < 990) return;
      HeaderMenu._closeTimer = setTimeout(() => {
        document.querySelectorAll('header-menu').forEach((el) => el.close());
      }, 200);
    });
  }

  onMouseEnter() {
    if (window.innerWidth < 990) return;
    clearTimeout(HeaderMenu._closeTimer);
    clearTimeout(this._openTimer);
    if (this.mainDetailsToggle.hasAttribute('open')) return;

    // A short dwell before opening: a quick pass-through on the way to an
    // already-open panel shouldn't switch anything, only a deliberate hover
    // should. Once it does open, immediately close any other open item —
    // switching tabs on purpose should still feel instant.
    this._openTimer = setTimeout(() => {
      document.querySelectorAll('header-menu').forEach((el) => {
        if (el !== this) el.close();
      });
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.onToggle();
    }, 150);
  }

  onMouseLeave() {
    if (window.innerWidth < 990) return;
    clearTimeout(this._openTimer);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
